<template>
    <div>
        <title-component></title-component>
        <guardians-menu-component></guardians-menu-component>
        <router-view></router-view>
    </div>
</template>

<script>
    import TitleComponent from './shared/TitleComponent'
    import GuardiansMenuComponent from './guardian/GuardiansMenuComponent'

    export default {
        name: 'Guardians',
        components: {
            'title-component': TitleComponent,
            'guardians-menu-component': GuardiansMenuComponent
        }
    }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/GuardiansMainComponent.vue